<div class="item-area" tabindex="0" [ngClass]="widget.isSelected ? 'item-selected' : 'item-unselected'"
  (click)="onSelectItem(widget)" 
  (keyup.Space)="onSelectItem(widget)"
  (contextmenu)="onContextMenu($event, widget)">
  <!-- <div [ngClass]="widget.placeholderClassName" *cdkDragPlaceholder></div> -->
  <div class="item-row" fxFlex="grow" title="{{getItemTooltip(widget)}}">
    <!-- <mat-icon [matBadge]="widget.badge" mat-list-icon (click)="onClickItem(widget)">{{widget.icon}}</mat-icon> -->
    <img class="item-icon" (click)="onSelectItem(widget);onClickItem(widget)" src="assets/img/icons/question.png" />
    <div class="item-title" *ngIf="isHidden" fxFlex="grow">{{widget.name}}</div>
    <container-element [ngSwitch]="widget.typeId">
      <img class="item-icon item-icon-type" *ngSwitchCase="1" src="assets/img/questions/yes_no.png" />
      <img class="item-icon item-icon-type" *ngSwitchCase="2" src="assets/img/questions/year.png" />
      <img class="item-icon item-icon-type" *ngSwitchCase="3" src="assets/img/questions/clock.png" />
      <img class="item-icon item-icon-type" *ngSwitchCase="4" src="assets/img/questions/complex.png" />
      <img class="item-icon item-icon-type" *ngSwitchCase="5" src="assets/img/questions/money.png" />
      <img class="item-icon item-icon-type" *ngSwitchCase="6" src="assets/img/questions/percentage.png" />
      <img class="item-icon item-icon-type" *ngSwitchCase="7" src="assets/img/questions/text.png" />
      <img class="item-icon item-icon-type" *ngSwitchCase="8" src="assets/img/questions/numericnew.png" />
      <img class="item-icon item-icon-type" *ngSwitchDefault src="assets/img/questions/yes_no.png" />
    </container-element>
  </div>
</div>

<!-- On right click on selected question in Question Library showing popup menu. -->
<div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x"
  [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu">
</div>
<mat-menu #contextMenu="matMenu">
  <ng-template matMenuContent let-item="item">
    <button mat-menu-item (click)="onShowPreviewAction(item)">Show Preview</button>
    <button mat-menu-item *ngIf="hasUserEditPermission()" (click)="onEditQuestionAction(item)">Edit</button>
    <button mat-menu-item (click)="onToggleAction(item)">Select</button>
  </ng-template>
</mat-menu>